import React from "react";
import { useParams } from "react-router-dom";
import ProductForm from "../common/ProductForm";
import AdminHeader from "./Header";
import { VIEW } from "../../include/constant";

const AdminViewProduct = () => {
    const { id } = useParams();
    return (
      <AdminHeader>
        <div
          className="fixed-top-bar"
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "43px",
          }}
        >
          <ProductForm
            id={id}
            title="View Product"
            type={VIEW}
            readonly={true}
          />
        </div>
      </AdminHeader>
    );
};

export default AdminViewProduct;